import {DropdownButton, Nav, Navbar, NavDropdown} from "react-bootstrap";
import {Link, useHistory} from "react-router-dom";
import {RoutePaths} from "./PageRoutesAuthenticated";
import React, {useContext, useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faCog,
  faUser
} from "@fortawesome/free-solid-svg-icons";
import {dateformatJPN, dateformatJPNYYYYMMDD, dateformatYYYYMMDD, logout} from "../CMUtil";
import {GlobalContext} from "../Global";

export const AppNav = () => {

  const history = useHistory();

  const [month, setMonth] = useState("");
  const {loginUser, setLoginUser} = useContext(GlobalContext);
  const [permission, setPermission] = useState("");

  //初期化
  useEffect(() => {
    const update = async () => {
      let yearStr = dateformatYYYYMMDD(new Date()).substring(0,4);
      let monthStr = dateformatYYYYMMDD(new Date()).substring(4,6);
      setMonth(yearStr + "-" + monthStr);
    }
    update();

    if(loginUser && loginUser.permission){
      setPermission(loginUser.permission.code_id);
    }
  }, []);

  const onClickMenu = (e, url) => {
    localStorage.removeItem("pay_grp_search_condition");
    localStorage.removeItem("pay_search_condition");
    localStorage.removeItem("exp_search_condition");
    localStorage.removeItem("roy_search_condition");
    history.push(url);
  }

  return (
    <Navbar expand="lg">
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          {(loginUser.dept === 'システム' || loginUser.dept === '経理') &&
            <Nav.Link onClick={e => onClickMenu(e, RoutePaths.root.pay_grp_list)}>
              支払ステータス
            </Nav.Link>
          }
          {(loginUser.dept === 'システム' || loginUser.dept === '経理') &&
            <Nav.Link onClick={e => onClickMenu(e, RoutePaths.root.pay_list)}>
              原稿料等
            </Nav.Link>
          }
          {(loginUser.dept === 'システム' || loginUser.dept === '経理') &&
            <Nav.Link onClick={e => onClickMenu(e, RoutePaths.root.exp_list)}>
              経費
            </Nav.Link>
          }
          {(loginUser.dept === 'システム' || loginUser.dept === '経理') &&
            <Nav.Link onClick={e => onClickMenu(e, RoutePaths.root.roy_list)}>
              印税
            </Nav.Link>
          }
          {(loginUser.dept === 'システム' || loginUser.dept === '営業') &&
          <Nav.Link onClick={e => onClickMenu(e, RoutePaths.root.item_list)}>
            マスタ取込
          </Nav.Link>
          }
          <Nav.Link as={Link} to={RoutePaths.root.pay_list}>
          </Nav.Link>
          <Nav.Link as={Link} to={"/auth/"} onClick={e => logout()}>
            ログアウト
          </Nav.Link>
          <Nav.Link style={{fontWeight:"bold"}}>
            {dateformatJPN(new Date())}
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
};

export default AppNav;